export const BUTTONS_LOADED_FAIL = 'app/ButtonsProvider/BUTTONS_LOADED_FAIL';
export const BUTTONS_LOADED_SUCCESS = 'app/ButtonsProvider/BUTTONS_LOADED_SUCCESS';
export const LOAD_BUTTONS = 'app/ButtonsProvider/LOAD_BUTTONS';
